import { TCommonParams } from '@cockpitai/integration/panels/types'
import { useContext, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PanelFilterExtrasContext } from './PanelFilterExtrasContext'

const commonFilters = ['affiliateId', 'occupationType', 'withoutWallet', 'supervisor', 'id']

export function useFilterPanels(extras?: readonly string[]): TCommonParams {
  const [searchParams] = useSearchParams()
  const panelExtras = useContext(PanelFilterExtrasContext)

  const extrasKey = extras ? extras.join(',') : ''
  const searchString = searchParams.toString()

  return useMemo(() => {
    const filtersPossible = extras ? [...commonFilters, ...extras] : commonFilters
    const filters: TCommonParams = {}

    for (const filter of filtersPossible) {
      if (searchParams.has(filter)) {
        const value = searchParams.get(filter)
        if (value !== null) {
          ;(filters as any)[filter] = value
        }
      }
    }

    return {
      ...filters,
      ...panelExtras,
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchString, panelExtras, extrasKey])
}
